import axios from '@/utils/http';
// 获取mixin 授权链接
export const getMixinAuth = () =>
  axios
    .get('/mixin/oauth/path')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
// 登录
export const loginIn = token =>
  axios
    .post('/auth/login', { token })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
// 退出
export const loginOut = () =>
  axios
    .delete('/auth/logout')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
// 刷新 token
export const updateToken = () =>
  axios
    .put('/auth/current')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
// 获取用户收款方式
export const getPayInfoList = () =>
  axios
    .get('/user/pay_info_list')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));

// 添加支付方式
export const postAddPayInfo = params => {
  return axios
    .post('/user/pay_info', params)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

// 修改支付方式
export const putPayInfo = (id, params) => {
  return axios
    .put(`/user/pay_info/${id}`, params)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

// 删除支付方式
export const deletePayInfo = id =>
  axios
    .delete(`/user/pay_info/${id}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));

export const getOrderPayInfo = orderId => {
  return axios
    .get(`/get_pay_method/${orderId}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const sendPayInfo = (orderId, payMethodId) =>
  axios
    .post(`/send_pay_method/${orderId}`, {
      pay_method_id: payMethodId,
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));

export const getUserAsset = assetId => {
  return axios
    .get(`/user/asset?asset_id=${assetId}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

/**
 * 设置默认收款方式
 * @param {*} id 收款方式id
 */
export const putUserPayDefault = (id, is_default) => {
  return axios
    .put(`/user/pay_info_default/${id}`, { is_default })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

/**
 * 设置收款方式是否可用
 * @param {*} id 收款方式id
 * @param {0｜1} isShow 是否可用
 */
export const putUserPayShow = (id, isShow = false) => {
  return axios
    .put(`/user/pay_info_show/${id}`, {
      is_show: +isShow,
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const checkToken = () => {
  return axios
    .get('/user/check_token')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const getUserList = (page = 1, per_page = 20, type = 1) => {
  return axios
    .get(
      `/merchant_customer_list?page=${page}&per_page=${per_page}&type=${type}`,
    )
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
/**
 * 添加到黑/白名单
 * @param {*} mixin_id 用户 mixin ID
 * @param {0|1} type 0 黑名单 1 白名单
 */
export const postAddToList = (mixin_id, type) => {
  return axios
    .post('/merchant_customer', { mixin_id, type })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const deleteFromList = id => {
  return axios
    .delete(`/merchant_customer/${id}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const getUserCommunitySettings = (conversationId = '') => {
  return axios
    .get(`/user_group?conversationId=${conversationId}`)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const postUserCommunitySettings = (
  conversation_id = '',
  asset_ids = [],
  property = 0,
) => {
  return axios
    .post('/user_group', {
      conversation_id,
      asset_ids,
      property,
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const postUserCommunity = conversationId => {
  return axios
    .post('/user_group/refresh', { conversationId })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const takeOffAds = () => {
  return axios
    .put('/advertisements_off')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

// 获取用户是否缓存了一键下架前的状态
export const getResumeAdsStatus = () => {
  return axios
    .get('/has_resume_advertisements')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const takeOnMyAds = () => {
  return axios
    .put('/advertisements_on')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const setUserDefaultCurrency = currencyId => {
  return axios
    .post('/user/set_default_legal_currency', {
      currency_id: currencyId,
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const getStatistics = (
  type = null,
  asset_id = null,
  legal_currency_id = null,
  start_time = null,
  end_time = null,
  is_adver = false,
) => {
  let url = '/user/order_statistics?';
  if (start_time) {
    url += `&start_time=${start_time}`;
  }
  if (end_time) {
    url += `&end_time=${end_time}`;
  }
  if (type) {
    url += `&type=${type}`;
  }
  if (asset_id) {
    url += `&asset_id=${asset_id}`;
  }
  if (legal_currency_id) {
    url += `&legal_currency_id=${legal_currency_id}`;
  }
  if (is_adver) {
    url += `&is_adver=${is_adver}`;
  }
  return axios
    .get(url)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const getInviteCode = () => {
  return axios
    .post('/get_inviter_code')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const postInviteeRate = invitee_rate => {
  return axios
    .post('/invitee_rate', { invitee_rate })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const postBindInviter = code => {
  return axios
    .post('/bind_inviter', { code })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

export const putUserGuide = () => {
  return axios
    .put('/user/read_guide')
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};

/**
 * 上报渠道来源
 * @param {string} channelId - 渠道ID
 */
export const reportChannelReferrer = channelId => {
  return axios
    .post('/user/channel_referrer', { channel_id: channelId })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};